export default __webpack_public_path__ + "static/media/view4_week_place_.a8d03bf5.csv";